import React from 'react';
import hoc from './FieldHOC';

class SelectField extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = {
      value: props.field.prop('payment_type') ? props.field.prop('payment_type') : 'onetime',
      period: 'M',
      periodValue: props.field.prop('subscription_period') ? props.field.prop('subscription_period') : 1
    };
  }

  onChange(e) {
    this.setState({
      value: e.target.value
    });
  }

  subscriptionPeriodChanged = (e) => {
    this.setState({
      period: e.target.value
    });
  };

  periodValueChanged = (e) => {
    this.setState({
      periodValue: e.target.value
    });
  };

  render() {
    let field = this.props.field;

    let options = [
      <option key="1" value="onetime">
        One-Time Payment
      </option>,
      <option key="2" value="subscription">
        Recurring Payment
      </option>
    ];

    let i = 1, max = 52, months = [];
    while (i < max) {
      months.push(<option key={i} value={i}>{i}</option>);
      i++;
    }

    return <div style={{opacity: field.prop('hidden_field') ? 0.5 : 1, display: !FW.inEditor() && field.prop('hidden_field') ? 'none' : null}}>
      <label htmlFor={this.props.name}>{this.props.title || field.get('title')}</label>
      {this.props.errorComponent}
      <select
        className="form-control"
        value={this.state.value}
        name={this.props.name}
        tabIndex={this.props.tabIndex}
        onChange={this.onChange.bind(this)}
      >
        {options}
      </select>

      {this.state.value === 'subscription' ? <div>
        <label htmlFor={this.props.name}>Recurrence Period</label>
        <select
          className="form-control"
          value={this.state.periodValue}
          name="subscription-period-value"
          onChange={this.periodValueChanged}
        >
          <option value="W">Weekly</option>
          <option value={1}>Monthly</option>
          <option value={3}>Quarterly</option>
          <option value={6}>Bi-Annually</option>
          <option value={12}>Annually</option>
        </select>
        {field.prop('subscription_amount') && field.prop('subscription_amount') !== '' ?
          <input type="hidden" value={field.prop('subscription_amount')} name="subscription-amount" />
          : null}
      </div> : null}
    </div>;
  }
}

export default hoc(SelectField);
